import _get from "lodash/get";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { PureComponent } from 'react';
import cx from 'classnames';
import { closest } from "../helpers/utils";
import FilterSort from "./FilterSort";
import StaticColumn from "./StaticColumn";
import ResizableColumn from "./ResizableColumn";

var Column =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Column, _PureComponent);

  function Column() {
    _classCallCheck(this, Column);

    return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
  }

  _createClass(Column, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          name = _props.name,
          children = _props.children,
          className = _props.className,
          resizable = _props.resizable,
          _onResize = _props.onResize,
          onResizeStart = _props.onResizeStart,
          _onResizeStop = _props.onResizeStop,
          options = _props.options,
          loadOptions = _props.loadOptions,
          height = _props.height,
          width = _props.width,
          maxWidth = _props.maxWidth,
          onResetAll = _props.onResetAll,
          onFilterChange = _props.onFilterChange,
          onSortChange = _props.onSortChange,
          isDragged = _props.isDragged,
          _onDragStart = _props.onDragStart,
          filterData = _props.filterData,
          order = _props.order,
          shouldRenderFilter = _props.shouldRenderFilter,
          shouldRenderSort = _props.shouldRenderSort,
          draggableOpts = _props.draggableOpts,
          title = _props.title,
          other = _objectWithoutProperties(_props, ["name", "children", "className", "resizable", "onResize", "onResizeStart", "onResizeStop", "options", "loadOptions", "height", "width", "maxWidth", "onResetAll", "onFilterChange", "onSortChange", "isDragged", "onDragStart", "filterData", "order", "shouldRenderFilter", "shouldRenderSort", "draggableOpts", "title"]);

      var Component = StaticColumn;
      var extraProps = {};
      var refCell = null;

      if (resizable) {
        Component = ResizableColumn;
        extraProps = {
          onResizeStart: onResizeStart,
          onResize: function onResize(e, data) {
            return _onResize(name, data.size.width);
          },
          onResizeStop: function onResizeStop(e, data) {
            return _onResizeStop(name, data.size.width);
          },
          minConstraints: [65],
          maxConstraints: maxWidth ? [maxWidth] : undefined,
          draggableOpts: draggableOpts
        };
      }

      var isActive = !!_get(filterData, 'values', []).length;
      var contentProps = {
        className: cx('nx-table__header-text', {
          'nx-table__header-text--active': isActive
        }),
        draggable: true,
        onDragStart: function onDragStart(e) {
          return _onDragStart(e, {
            name: name,
            label: children,
            cell: refCell
          });
        },
        ref: function ref(el) {
          return refCell = closest(el, 'th');
        }
      };
      var content = React.createElement("span", contentProps, children);
      var columnTitle = typeof title === 'string' ? title : children;
      return React.createElement(Component, _extends({
        className: cx('nx-table__header-cell', className, {
          'nx-table__header-cell--is-dragging': isDragged
        }),
        height: height,
        width: width,
        title: columnTitle
      }, extraProps), other.type ? React.createElement(FilterSort, _extends({}, other, {
        name: name,
        options: options,
        loadOptions: loadOptions,
        className: "nx-table__header-filter-sort",
        title: columnTitle,
        onResetAll: onResetAll,
        onFilterChange: onFilterChange,
        onSortChange: onSortChange,
        filterData: filterData,
        order: order,
        isActive: isActive,
        shouldRenderFilter: shouldRenderFilter,
        shouldRenderSort: shouldRenderSort
      }), content) : content);
    }
  }]);

  return Column;
}(PureComponent);

export { Column as default };